// extracted by mini-css-extract-plugin
export var sectionTitleHolder = "PageElements-module--sectionTitleHolder--3Fadw";
export var superTitleHolder = "PageElements-module--superTitleHolder--SWikb";
export var heroTitleHolder = "PageElements-module--heroTitleHolder--3dIxT";
export var heroSubtitleHolder = "PageElements-module--heroSubtitleHolder--3NKiv";
export var heroHolder = "PageElements-module--heroHolder--2JP6_";